import { paletteTheme } from "@configs/theme/custom/palette";

export const tableTheme = {
  headerBg: paletteTheme.colorFillSecondary,
  headerBorderRadius: 6,
  headerColor: paletteTheme.colorIcon,
  cellFontSizeSM: 12,
  headerSplitColor: "transparent",
  borderColor: paletteTheme.colorFillSecondary,
};
